var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g({class:_vm.iconClass(),style:(_vm.fontSize()),on:{"click":function($event){return _vm.onClick()},"mouseup":function($event){if('button' in $event && $event.button !== 1)return null;return _vm.onClickMiddle()}}},_vm.on),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }